<button class="btn-ghost export-file">
  <app-icon name="upload" [size]="15" [strokeWidth]="2"></app-icon>
  <span>{{label}}</span>
</button>
